import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { lastValueFrom, take } from 'rxjs';
import { State } from 'src/app/core/state/core.state';
import * as fromPath from 'src/app/core/state/path';
import * as fromSubscriber from 'src/app/core/state/subscriber';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import { GtmService } from './google-tag-manager.service';

export type GtmTrackedEvent = 'price_view' | 'form_devis_submit' | 'contract_signature_submit';

@Injectable({
  providedIn: 'root'
})
export class GtmEventServiceService {
  constructor(
    private store: Store<State>,
    private gtmService: GtmService,
    private encryptionService: EncryptionService
  ) {}

  async pushEvent(eventName: GtmTrackedEvent): Promise<void> {
    const subscriber = await lastValueFrom(
      this.store.select(fromSubscriber.selectSubscriber).pipe(take(1))
    );
    const path = await lastValueFrom(this.store.select(fromPath.selectPathType).pipe(take(1)));

    const offer = path + '_' + environment.brand;
    const email = subscriber.subscriber?.Email ?? '';
    const hashedEmail = email ? await this.encryptionService.sha256Hex(email) : '';
    const phonePrefix =
      subscriber.subscriber?.Telephone !== undefined && subscriber.subscriber?.Telephone !== ''
        ? (subscriber.subscriber?.Indicatif ?? '') + subscriber.subscriber?.Telephone
        : '';

    this.gtmService.pushEvent(eventName, {
      user_data_em: hashedEmail,
      user_data_ph: phonePrefix,
      form_name: offer
    });
  }
}
